import { View } from "@tarojs/components";
import React from "react";
export function ListDivider() {
    return React.createElement(View, { className: "tea-list-divider" });
}
//# sourceMappingURL=ListDivider.js.map